import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import useModularPDPCustomerPhotosAndReviews from 'data-hooks/useModularPDPCustomerPhotosAndReviews';
import getRoundedRating from 'commons/getRoundedRating';
import useIsBrowser from 'hooks/useIsBrowser';
const ModularPDPRatingAndReviews = t0 => {
  const $ = _c(14);
  const {
    onClick,
    href
  } = t0;
  const isBrowser = useIsBrowser();
  const modularCustomerReviewsData = useModularPDPCustomerPhotosAndReviews();
  let t1;
  if ($[0] !== modularCustomerReviewsData) {
    t1 = modularCustomerReviewsData || {};
    $[0] = modularCustomerReviewsData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    loading,
    customer_photos_min: t2,
    customer_reviews: t3
  } = t1;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    totalPhotos
  } = t4;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    totalReviews,
    averageRating
  } = t5;
  let t6;
  if ($[6] !== averageRating) {
    t6 = getRoundedRating(averageRating);
    $[6] = averageRating;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const roundedRating = t6;
  const hasData = totalPhotos !== undefined || totalReviews !== undefined;
  const isLoading = loading || !hasData || !isBrowser;
  const t7 = (totalPhotos || 0) + (totalReviews || 0);
  let t8;
  if ($[8] !== href || $[9] !== isLoading || $[10] !== onClick || $[11] !== roundedRating || $[12] !== t7) {
    t8 = <RatingAndReviews loading={isLoading} rating={roundedRating} numberOfReviews={t7} onClick={onClick} href={href} />;
    $[8] = href;
    $[9] = isLoading;
    $[10] = onClick;
    $[11] = roundedRating;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
ModularPDPRatingAndReviews.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string
};
export default ModularPDPRatingAndReviews;